import { Box, Divider, Typography } from "@mui/material";
import { TimelineTooltipPayload, validateDate } from "../../utils/utils";
import GroupInteractionItem from "./GroupInteractionItem";
import EmailTooltip from "./EmailTooltip";
import "../../styles/account.css";

const CombinedTooltip = ({
  interactions,
  emailIds,
  navigationState,
  groupDateKey,
  anchorInteractionId,
}: TimelineTooltipPayload) => {
  const interactionItems = interactions.filter(
    (i) => i.type === "interaction"
  );

  const emailItems = interactions.filter(
    (i) => i.type === "email"
  );
  const sortedItems = [...interactions].sort(
    (a, b) =>
      new Date(a.start_time).getTime() - new Date(b.start_time).getTime()
  );
  const tooltipDate = sortedItems[0]?.start_time || "";

  return (
    <Box className="interaction-tooltip combined-tooltip">
      <Box className="interaction-tooltip__header">
        <Typography variant="h5">
          {interactionItems.length} Interaction
          {interactionItems.length > 1 ? "s" : ""}
          {" & "}
          {emailItems.length} Email
          {emailItems.length > 1 ? "s" : ""}
        </Typography>

        <Typography className="interaction-tooltip__date">
          {validateDate(tooltipDate, "DD MMM, YYYY")}
        </Typography>
      </Box>

      <Divider className="interaction-tooltip__divider" />

      <Box className="combined-tooltip__content">
        {sortedItems.map((item, index) => (
          <Box key={`${item.type}-${item.id || index}`}>
            {item.type === "interaction" ? (
              <GroupInteractionItem
                interaction={item}
                isLast
                navigationState={navigationState}
                groupDateKey={groupDateKey}
                anchorInteractionId={anchorInteractionId}
                allInteractions={interactions}
              />
            ) : (
              <Box className="combined-tooltip__section combined-tooltip__section--emails">
                <EmailTooltip
                  mode="group"
                  interactions={[item]}
                  emailIds={item.id ? [item.id] : emailIds}
                  embedded
                />
              </Box>
            )}
            {index !== sortedItems.length - 1 && (
              <Divider className="combined-tooltip__section-divider" />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CombinedTooltip;
